import React, { useEffect, useState } from "react";
import { Col } from "reactstrap";
import { useQuery } from "@apollo/react-hooks";
import { httpClient } from "../../settings/apolloClient";
import { SimpleDataContainer } from "../ConfirmModal/confirmModalComponents";
import InfoContainer from "../FormTextField/InfoContainer";
import { SHIPMENT_CONTRACT_INFOS } from "../../graphql/queries/get/gqlSelectQueries";

const styles = {
  container: {
    padding: "0 30px 30px 30px",
  },
};

const extractOptions = (items, key) => (items || []).filter(Boolean).map((item) => ({ value: item[key], label: item[key] }));

export const ShipmentInfo = ({
  request,
  setParams,
}) => {
  const { data } = useQuery(SHIPMENT_CONTRACT_INFOS, {
    fetchPolicy: "network-only",
    client: httpClient,
  });

  const {
    constructionAddress,
    constructionName,
    contractCode,
    equipmentPlate,
  } = request || {};

  const initialValues = {
    contractCode,
    constructionName,
    constructionAddress,
    equipmentPlate,
  };

  const [formState, setFormState] = useState(initialValues);
  const [options, setOptions] = useState({
    contractCode: [],
    constructionName: [],
    constructionAddress: [],
    equipmentPlate: [],
  });

  useEffect(() => {
    if (data && data.shipmentContractInfos) {
      const infos = data.shipmentContractInfos.contractInfos || [];
      const equipmentPlates = data.shipmentContractInfos.equipmentPlates || [];

      setOptions({
        contractCode: extractOptions(infos, "contractCode"),
        constructionName: extractOptions(infos, "constructionName"),
        constructionAddress: extractOptions(infos, "constructionAddress"),
        equipmentPlate: equipmentPlates.map((plate) => ({
          value: plate,
          label: plate,
        })),
      });
    }
  }, [data]);

  useEffect(() => {
    setParams((prev) => ({
      ...prev,
      ...formState,
    }));
  }, [formState]);

  const fields = [
    { title: "Código de Contrato", key: "contractCode" },
    { title: "Nome da Obra ou Cliente", key: "constructionName" },
    { title: "Endereço", key: "constructionAddress" },
    { title: "Placa Caminhão", key: "equipmentPlate" },
  ];

  const handleFieldChange = (key, value) => {
    setFormState((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div style={styles.container}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <h3>Informações Complementares</h3>
      </div>

      <SimpleDataContainer style={{ justifyContent: "flex-start" }}>
        {fields.map(({ title, key }) => (
          <Col key={key} sm={12} md={12} lg={6}>
            <InfoContainer
              title={title}
              value={formState[key]}
              canEdit={formState[key] == null}
              options={options[key]}
              handleChange={(value) => handleFieldChange(key, value)}
              setOptions={(opts) => setOptions((prev) => ({ ...prev, [key]: opts }))}
            />
          </Col>
        ))}
      </SimpleDataContainer>
    </div>
  );
};
